import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';

import {ESignatureRoutingModule} from './e-signature-routing.module';
import {SignMenuComponent} from './sign-menu/sign-menu.component';
import {DragulaModule} from 'ng2-dragula';
import {ChangePassSignComponent} from './register-signature/change-pass-sign/change-pass-sign.component';
import {RegisterSignatureComponent} from './register-signature/register-signature.component';
import {TasksComponent} from './tasks/tasks.component';
import {TaskFilterSelectComponent} from './tasks/task-filter-select/task-filter-select.component';
import {TemplatesComponent} from './templates/templates.component';
import {ContactComponent} from './contact/contact.component';
import {SignOffComponent} from './sign-off/sign-off.component';
import {MailFlowComponent} from './mail-flow/mail-flow.component';

import {ViewFlowComponent} from './view-flow/view-flow.component';
import {NewTaskComponent} from './tasks/new-task/new-task.component';
import {UploadDocumentComponent} from './tasks/upload-document/upload-document.component';
import {MainSiteFlowComponent} from './main-site-flow/main-site-flow.component';
import {StepProgressComponent} from './step-progress/step-progress.component';
import {AddRecipientsComponent} from './mail-flow/add-recipients/add-recipients.component';
import {FlowRecipientsComponent} from './mail-flow/flow-recipients/flow-recipients.component';
import {MessageRecipientsComponent} from './mail-flow/message-recipients/message-recipients.component';
import {ActionComponent} from './sign-off/action/action.component';
import {DocumentListComponent} from './sign-off/document-list/document-list.component';
import {LeftPanelComponent} from './sign-off/left-panel/left-panel.component';
import {PropertiesComponent} from './sign-off/properties/properties.component';
import {SignListComponent} from './sign-off/sign-list/sign-list.component';
import {ToolsComponent} from './sign-off/tools/tools.component';
import {ViewDocumentComponent} from './sign-off/view-document/view-document.component';
import {WorkflowComponent} from './workflow/workflow.component';
import {NewWorkflowComponent} from './workflow/new-workflow/new-workflow.component';
import {FlowComponent} from './view-flow/flow/flow.component';
import {EditActionComponent} from './mail-flow/edit-action/edit-action.component';
import {ConfirmDialogComponent} from './confirm-dialog/confirm-dialog.component';
import {NewContactComponent} from './contact/new-contact/new-contact.component';
import {NewGroupComponent} from './contact/new-group/new-group.component';
import {SignDocumentComponent} from './sign-document/sign-document.component';
import {SignDialogComponent} from './sign-document/sign-dialog/sign-dialog.component';
import {SetpasswordDialogComponent} from './setpassword-dialog/setpassword-dialog.component';
import {AuthenSignComponent} from './authen-sign/authen-sign.component';
import {CreateTaskSignOffComponent} from './sign-off/create-task-sign-off/create-task-sign-off.component';
import {SignTaskComponent} from './sign-off/sign-task/sign-task.component';
import {RejectTaskDialogComponent} from './reject-task-dialog/reject-task-dialog.component';
import {GroupComponent} from './contact/group/group.component';
import {RejectReasonComponent} from './tasks/reject-reason/reject-reason.component';
import {CreateTaskComponent} from './create-task/create-task.component';
import {TestLibComponent} from './test-lib/test-lib.component';
import {ThumbnailComponent} from './sign-document/thumbnail/thumbnail.component';
import {DeleteDialogComponent} from './delete-dialog/delete-dialog.component';
import {ConfirmDialogCreateTaskComponent} from './confirm-dialog-create-task/confirm-dialog-create-task.component';
import {ReassignDialogComponent} from './tasks/reassign-dialog/reassign-dialog.component';
import {LogAssignDialogComponent} from './view-flow/log-assign-dialog/log-assign-dialog.component';
import {PreviewDocumentDialogComponent} from './tasks/preview-document-dialog/preview-document-dialog.component';
import {ConfirmRemovesignDialogComponent} from './confirm-removesign-dialog/confirm-removesign-dialog.component';
import {HistoryActivityDialogComponent} from './history-activity-dialog/history-activity-dialog.component';
import {ExportTaskDialogComponent} from './export-task-dialog/export-task-dialog.component';
import {DmsModule} from '../dms/dms.module';
import {AdvanceSearchDialogComponent} from './advance-search-dialog/advance-search-dialog.component';
import {AttachFileComponent} from './attach-file/attach-file.component';
import { DeleteAttachFileComponent } from './delete-attach-file/delete-attach-file.component';
import { PackageDialogComponent } from './tasks/package-dialog/package-dialog.component';
import { SenderListComponent } from './sender-list/sender-list.component';
import { AutoApproveComponent } from './auto-approve/auto-approve.component';
import { CommentboxComponent } from './comment-pdf/commentbox/commentbox.component';
import { CommentsComponent } from './comment-pdf/comments/comments.component';
import {ShareComponent} from './share/share.component';
import {FilterPipe} from '../shared/text-search/pipes/filter.pipe';
import {EFormModule} from '../e-form';
import { ConfirmCertificateComponent } from './confirm-certificate/confirm-certificate.component';
import { IgnoreCertificateComponent } from './ignore-certificate/ignore-certificate.component';
import { ConfirmCertificateSiteComponent } from './confirm-certificate-site/confirm-certificate-site.component';
import { SelectFileDocumentComponent } from './tasks/select-file-document/select-file-document.component';
import {ColorPickerModule} from 'ngx-color-picker';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { IncludeAuditTrailComponent } from './sign-off/include-audit-trail/include-audit-trail.component';
import { SenderReassignDialogComponent } from './tasks/sender-reassign-dialog/sender-reassign-dialog.component';
import { ExternalSignComponent } from './external-sign/external-sign.component';
import { ExternalSignatureComponent } from './external-signature/external-signature.component';
import { ExternalCompletedComponent } from './external-completed/external-completed.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        ESignatureRoutingModule,
        DragulaModule.forRoot(),
        DmsModule,
        EFormModule,
        ColorPickerModule,
        MatButtonToggleModule,
        TaskFilterSelectComponent
    ],
    declarations: [
        SignMenuComponent,
        ChangePassSignComponent,
        RegisterSignatureComponent,
        TasksComponent,
        TemplatesComponent,
        ContactComponent,
        SignOffComponent,
        MailFlowComponent,
        ViewFlowComponent,
        NewTaskComponent,
        UploadDocumentComponent,
        SelectFileDocumentComponent,
        MainSiteFlowComponent,
        StepProgressComponent,
        AddRecipientsComponent,
        FlowRecipientsComponent,
        MessageRecipientsComponent,
        ActionComponent,
        DocumentListComponent,
        LeftPanelComponent,
        PropertiesComponent,
        SignListComponent,
        ToolsComponent,
        ViewDocumentComponent,
        WorkflowComponent,
        NewWorkflowComponent,
        FlowComponent,
        EditActionComponent,
        ConfirmDialogComponent,
        NewContactComponent,
        NewGroupComponent,
        SignDocumentComponent,
        SignDialogComponent,
        SetpasswordDialogComponent,
        AuthenSignComponent,
        CreateTaskSignOffComponent,
        SignTaskComponent,
        RejectTaskDialogComponent,
        GroupComponent,
        RejectReasonComponent,
        CreateTaskComponent,
        TestLibComponent,
        ThumbnailComponent,
        DeleteDialogComponent,
        ConfirmDialogCreateTaskComponent,
        ReassignDialogComponent,
        LogAssignDialogComponent,
        PreviewDocumentDialogComponent,
        ConfirmRemovesignDialogComponent,
        HistoryActivityDialogComponent,
        AdvanceSearchDialogComponent,
        RejectTaskDialogComponent,
        ExportTaskDialogComponent,
        AttachFileComponent,
        DeleteAttachFileComponent,
        PackageDialogComponent,
        SenderListComponent,
        AutoApproveComponent,
        CommentboxComponent,
        CommentsComponent,
        ShareComponent,
        FilterPipe,
        ConfirmCertificateComponent,
        IgnoreCertificateComponent,
        ConfirmCertificateSiteComponent,
        IncludeAuditTrailComponent,
        SenderReassignDialogComponent,
        ExternalSignComponent,
        ExternalSignatureComponent,
        ExternalCompletedComponent
    ],
    exports: [SignMenuComponent]
})
export class ESignatureModule {
}
